export enum FetchMetaKey {
  ORDERS = 'orders',
  ORDER = 'order',
  RESERVATION = 'reservation',
  CONTENT_BLOCK = 'content-block',
  APPLICATION_ENVIRONMENT = 'application-environment',
}
export interface FetchMeta {
  key: FetchMetaKey | string // order:$token | application-environment:$domain | reservation:$token
  fetchedAt: string
}

export interface OrderSummary {
  token: string
  date: string
}
